import React from 'react';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const getPaletteColorFromSemanticColor = (theme, color) => {
  switch (color) {
    case 'emphasized':
      return theme.palette.divider;
    case 'info':
      // The theme.palette.info colors in the theme that comes from MUI V4 do not quite match the one that we have defined in the DS.
      // The colors defined in theme.palette.primary align much better with the info palette that is defined in FD, so using those colors for the
      // 'info' color for now. When we pull this component into the DS we will be able to just use theme.palette[color].main as the border color
      // for all of the semantics info, warning, error, and success.
      return theme.palette.primary.main;
    case 'warning':
    case 'error':
    case 'success':
      return theme.palette[color].main;
    default:
      return theme.palette.divider;
  }
};

// This component provides a bordered box that is one of our semantic colors (eg. info, success, etc.)
// and has NO fill color. This is used pretty extensively throughout scenario selection and it might make sense to
// bring it into FD.
export const BorderedTransparentBox = ({
  children, padding, color, ...restProps
}) => {
  const theme = useTheme();

  const borderColor = getPaletteColorFromSemanticColor(theme, color);

  return (
    <Box
      sx={{
        backgroundColor: 'transparent',
        border: `1px solid ${borderColor}`,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(padding),
        height: '100%',
      }}
      {...restProps}
    >
      {children}
    </Box>

  );
};

BorderedTransparentBox.defaultProps = {
  padding: 0,
  color: undefined,
};

BorderedTransparentBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  color: PropTypes.oneOf(['info', 'warning', 'error', 'success', 'emphasized']),
  padding: PropTypes.number,
};
